import * as rudderStackAnalytics from 'rudder-sdk-js';
export var initRudderStack = function initRudderStack() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  rudderStackAnalytics.ready(function () {
    console.info('RudderStack ready.');
  });
  rudderStackAnalytics.load(config.writeKey, config.dataPlaneUrl);
  return rudderStackAnalytics;
};